import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import TabsNavbar from "../Common/TabsNavBar/TabsNavbar";
import { getDelivery } from "../../REDUX/actions/delivery";
import DepartureForms from "./DepartureForms";
import { Spinner } from "react-bootstrap";

const UpdateDeparture = ({ id, initialTab }) => {
  const TABS = [
    "General infos",
    "Preparation",
    "Delivery",
    "Reception",
    "Attachments",
    "Exchange",
  ];
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.userReducer);
  if ([1, 4]?.includes(user?.attributes?.userRole)) {
    TABS.push("Invoice");
  }

  const [activeTab, setActiveTab] = useState(
    TABS?.find((tab) => tab === initialTab) ?? TABS[0]
  );

  const { delivery, deliveryLoading, updateDeliveryLoading } = useSelector(
    (state) => state.deliveryReducer
  );
  const [forms, setForms] = useState({
    preparation: {},
    delivery: {},
    reception: {},
    comments: [],
  });

  useEffect(() => {
    dispatch(getDelivery(id));
    return () => {
      dispatch({ type: "CLEAR_DELIVERY" });
    };
  }, [id, dispatch]);

  return (
    <div className="newRevendeur d-flex flex-column justify-content-between h100 min-w-1110px">
      <div className="flex-1 d-flex flex-column">
        <div className="alignH align-items-end">
          <h2 className={`sBold f25 quickSand text-blue ${"px-5"} mb-5`}>
            {t("Delivery")}
            {`${
              delivery?.attributes?.number
                ? ` #${delivery?.attributes?.number}`
                : ""
            }`}
          </h2>
        </div>
        <TabsNavbar
          tabs={TABS}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          className={TABS?.length > 5 ? "gap-3" : "gap-5"}
        />

        <div className="modalContent px-5 pt-4 pb-5 position-relative">
          {(deliveryLoading || updateDeliveryLoading) &&
            activeTab !== "Attachments" && (
              <div className="position-absolute top-0 start-0 w-100 h-100 bg-white bg-opacity-50 z-9999 d-flex align-items-center justify-content-center">
                <Spinner />
              </div>
            )}
          <DepartureForms
            activeTab={activeTab}
            forms={forms}
            setForms={setForms}
          />
        </div>
      </div>
    </div>
  );
};

export default UpdateDeparture;
